<template>
  <div class="row scan-history-view">
    <mdb-row>
      <div v-show="showSpinner">
        <Spinner />
      </div>
    </mdb-row>

    <mdb-row>
      <mdb-input
        v-model.trim="search"
        @keyup.native.enter="searchScans"
        label="Search"
        placeholder="Enter Bag Code"
        validated
      />
    </mdb-row>

    <mdb-row>
      <Errors v-if="!!error" :error="error" />
    </mdb-row>

    <mdb-row>
      <mdb-tbl striped class="wide">
        <mdb-tbl-head>
          <tr>
            <th>Asset Type</th>
            <th>Code</th>
            <th>Location</th>
            <th>Status</th>
            <th>Scan Time</th>
            <th>Sync Status</th>
            <th>Returned </th>
            <th>Returned At </th>
          </tr>
        </mdb-tbl-head>

        <transition-group tag="tbody" name="fade">
          <tr v-for="scan in scans.rows.slice(0, showLimit)" :key="scan.key">
            <td>{{ scan.asset_type }}</td>
            <td>{{ scan.code }}</td>
            <td>{{ scan.location }}</td>
            <td>{{ scan.scan_state }}</td>
            <td>{{ scan.scan_time | formatDate }}</td>
            <td>{{ scan.sync_status }}</td>
            <td>{{ !!scan.returned }}</td>
            <td>{{ scan.returned_at | formatDate }} </td>
          </tr>
        </transition-group>
      </mdb-tbl>
    </mdb-row>

    <div class="failedSection">
      <h4>Failed Scans</h4>
      <mdb-row>
        <mdb-tbl striped class="wide">
          <mdb-tbl-head>
            <tr>
              <th>Asset Type</th>
              <th>Code</th>
              <th>Location</th>
              <th>Status</th>
              <th>Scan Time</th>
              <th>Sync Status</th>
            </tr>
          </mdb-tbl-head>

          <transition-group tag="tbody" name="fade">
            <tr v-for="fscan in failedScans.rows" :key="fscan.key">
              <td>{{ fscan.asset_type }}</td>
              <td>{{ fscan.code }}</td>
              <td>{{ fscan.location }}</td>
              <td>{{ fscan.scan_state }}</td>
              <td>{{ fscan.scan_time | formatDate }}</td>
              <td>{{ fscan.sync_status }}</td>
            </tr>
          </transition-group>
        </mdb-tbl>
      </mdb-row>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { mdbInput, mdbRow, mdbTbl, mdbTblHead } from "mdbvue";
import Spinner from "@/components/Spinner";
import Errors from "@/components/Errors";
import dateFns from "date-fns";

export default {
  name: "ScanHistory",
  components: {
    mdbInput,
    mdbRow,
    Spinner,
    Errors,
    mdbTbl,
    mdbTblHead,
  },
  filters: {
    formatDate(date) {
      if(!date) { return null } 
      return dateFns.format(date, "MMM Do [at] h:mm:ss a");
    },
  },
  data() {
    return {
      isLoading: false,
      search: "",
      error: "",
      showLimit: 50, //Number of records to display for scanHistory
      scans: {
        rows: [],
      },
      failedScans: {
        rows: [],
      },
    };
  },
  created() {
    this.getRecentScans();
    this.loadFailedScans();
  },
  methods: {
    getRecentScans() {
      api
        .getRecentScans()
        .then((response) => {
          this.scans.rows.push(...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
          this.isLoading = false;
        });
    },

    loadFailedScans() {
      this.failedScans.rows = this.$store.state.failedSyncHistory.data;
    },

    performSearch() {
      api
        .findScan(this.search)
        .then((response) => {
          this.error =
            response.data.length < 1
              ? "No record matching your search criteria. Please check item code and try again"
              : "";
          this.scans.rows.splice(0, this.scans.rows.length, ...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          this.error = e.response.data.message;
          this.isLoading = false;
        });
    },

    searchScans() {
      if (this.search != "") {
        this.isLoading = true;
        this.performSearch();
      }
    },
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.wide {
  width: 80vw;
}

th {
  font-weight: bold;
  color: $black-accent-color;
}

.failedSection {
  padding-top: 3rem;
}
</style>
